import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import SmallLoader from "components/common/SmallLoader";
import { useEffect } from "react";
import * as staticDataService from "services/staticDataService";

const NULL_KEY = "__NULL__";
const LOADING_KEY = "__LOADING__";

const PaperProviderInput = ({ defn, options, setOptions }) => {
  const {
    data: config,
    isLoading: isConfigLoading,
    isError,
  } = staticDataService.useConfigQuery("reinsurers");

  useEffect(() => {
    if (!isConfigLoading) {
      setOptions((currentOptions) => ({
        ...currentOptions,
        [defn.name]: null,
      }));
    }
  }, [defn.name, setOptions, isConfigLoading]);

  return (
    <FormControl variant={"filled"} sx={{ width: 272 }} error={isError}>
      <InputLabel shrink>{"Security"}</InputLabel>
      <Select
        value={isConfigLoading ? LOADING_KEY : options[defn.name] ?? NULL_KEY}
        onChange={(e) => {
          const value = e.target.value === NULL_KEY ? null : e.target.value;
          setOptions({
            ...options,
            [defn.name]: value,
          });
        }}
        disabled={isConfigLoading}
      >
        {isConfigLoading && (
          <MenuItem value={LOADING_KEY}>
            <SmallLoader />
          </MenuItem>
        )}
        <MenuItem value={NULL_KEY}>{"Any"}</MenuItem>
        {config?.reinsurers?.map((reinsurer) => (
          <MenuItem key={reinsurer.key} value={reinsurer.key}>
            {reinsurer.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PaperProviderInput;
